<template>        
  <div>                   
    <input type="file" :id="'imageUpload-'+carForSaleID" name="imageName" multiple @change='onFileChange' ><br/>    
    <div class="row">        
        <div class="col-xs-6 col-md-3" v-for='imageList in imageLists' >            
            <div class="thumbnail" >                
                <img v-bind:src="$http.options.root + imageFolderPath + imageList.name" alt="Imagen" height="120" width="120"><br>       
                <label>                    
                    <span style='font-size: 2em;'>&nbsp;&nbsp;                                                
                        <span class="glyphicon glyphicon-asterisk" title='Foto Principal'            style="color:#4db8ff;" v-show='imageList.priority == 1' ></span>                        
                        <span class="glyphicon glyphicon-ok"       title='Poner como foto principal' style="color:#39e600;" v-show='imageList.priority != 1'  @click='putPrincipalImage(imageList)' ></span>
                        <span class='glyphicon glyphicon-remove'   title='Borrar'                    style="color:#ff471a;" @click='deleteImage(imageList)'></span>                        
                    </span>
                </label>
            </div>            
        </div>          
    </div>  
  </div>  
</template>

<script>
import { eventBus } from '../main';
export default {  
  data: function () {     
    return {       
       fileInput: {},       
       imageLists: [],
       imageListsTmp: [],
       principalImage: '',       
       imageFolderPath: '/uploads/',
       PrincipalImageStyle: 'background-color:: cadetblue;',
       NonPrincipalImageStyle: 'background-color:: red;'
    }
  },
  mounted: function () {   
      setTimeout(() => {
        this.getCarImages();
      }, 100);            
  },
  methods: { 
   getCarImages : function(){       
       if(this.carForSaleID == 0)
        return;

        this.$http.get('api/imageupload/carid/' + this.carForSaleID).then(response => {                                    
           this.imageLists = response.body;                     
           this.gotData = true;                     
        }, response => {            
            eventBus.$emit('errorMsg',response);
        });
    },
    deleteImage: function({id,name}){                                
        if(this.carForSaleID > 0){            
            this.$http.delete('api/imageupload/' + id).then(response => {                                              
                this.getCarImages();
            }, response => {
                eventBus.$emit('errorMsg',response);
            });
        }
        else {                        
            this.imageLists = this.imageListsTmp.filter(function(obj) {
                return obj.name != name;
            });

            this.imageListsTmp = this.imageLists;
            eventBus.$emit('imageUpload',this.imageLists);      
            
            if(this.imageLists[0]){
                this.imageLists[0].priority = 1;
                eventBus.$emit('imageSelected',this.imageLists[0].name);                                              
            }
        }
    },
    putPrincipalImage: function({id,name}){                        

        if(this.carForSaleID > 0){
            this.imageLists.map((obj) => {
                var updateObj = false;
                if(obj.priority == 1){
                    obj.priority = 99;
                    updateObj = true;
                }
                    
                if(obj.id == id){
                    obj.priority = 1;
                    updateObj = true;
                }   

                if(updateObj){
                    this.$http.put('api/imageupload/updatepriority/' + obj.id, obj).then(response => {                                              
                                            
                    }, response => {
                        eventBus.$emit('errorMsg',response);
                    });
                }            
            });
        }
        else {
            this.imageLists = this.imageLists.map((obj) => { 
                                   
                                    if(obj.name == name){
                                        eventBus.$emit('imageSelected',name);      
                                        obj.priority = 1;
                                    }
                                    else
                                        obj.priority = 99;

                                    return obj;
                                });            
        }                
    },    
    onFileChange: function(e){      
      
      e.preventDefault();                

      var form = document.querySelector('#' + e.target.id);        
      var formData = new FormData();

      for(var key in form.files)
        if(!isNaN(key))
          formData.append('imageName', form.files[key]);                                            
      
      if(form.files.length > 0) {        
        this.$http.post('api/imageupload/temp', formData).then(response => {                   
            if(response.status == 200) {                                                        
            
                var firstImage = true;

                if(this.imageLists.length > 0)
                    firstImage = false;

                //this.imageListsTmp = [];
                
                response.body.forEach((obj) => {                    

                    var objTemp    = {};
                    objTemp.id     = 0;
                    objTemp.name   = obj.filename;
                    objTemp.active = 1;
                    
                    if(firstImage) {
                        objTemp.priority = 1;
                        firstImage = false;
                    }
                    else
                        objTemp.priority = 99;
                    
                    this.imageLists.push(objTemp);
                    this.imageListsTmp.push(objTemp);
                });
                                
                eventBus.$emit('imageUpload',this.imageListsTmp);      
                
                if(this.imageLists[0])
                    eventBus.$emit('imageSelected',this.imageLists[0].name);                                              
            }                
        }, response => {            
                                          
        });     
      }     
    }    
  },
  filters: {
     
  },
  computed: {
    
  },
  props:['carForSaleID']
}
</script>

<style scoped>
  .btnWidthSentPhoto{
        width:200px;        
        display:inline-block;      
   }

   .PrincipalImageStyle {
        background: cadetblue;
   }
   
   .NonPrincipalImageStyle{
        background: red;
   }

</style>



// WEBPACK FOOTER //
// ImageUpload.vue?b4aa9368